import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./common/print.css";
import { Card, CardBody, CardHeader, Col, Modal, Button, ModalHeader, Row, ModalFooter, ModalBody, CardFooter } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import ReactToPrint from "react-to-print";
import { configuration } from "../appConfig";
import PageNo from "./common/PageNo";
import SwissPriceTable from "./common/SwissPriceTable";
import { calculatePrice } from "../pricing/calculatePrice";
import SlovinaPriceTable from "./common/SlovinaPriceTable";
import ExtraImages from "./ExtraImages";
import CustomerInfoTable from "./common/CustomerInfoTable";
import CustomerInfoTableSwiss from "./common/CustomerInfoTable_swiss";
import CarSVG from "../carbodyparts/CarSvg";
import { connect } from "react-redux";
import PlotDentOnExtraImage from "./PlotDentOnImage/PlotDentOnExtraImage";
import ScrollToTop from "./common/ScrollToTop";
import "./newstyle.css";
import NewSwissPriceTable from "./common/NewSwissPriceTable";
import CarSvgSwiss from "../carbodyparts/CarSvgSwiss";
import { updateJsonData } from "../redux/actions/updateJsonData";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import { token } from "../appTokenConfig";
import SwissMiniReportAuthorization from "./common/SwissMiniReportAuthorization";

function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}


const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

class NewReportMiniSwiss extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: Math.round(Math.random() * 100000000),
      issuedOn: new Date(),
    },
    words: {},
    lang: "gb",
    Authorized: false,
    deAuthLoading: false,
    loading: false,
    jsonData: {},
    MiniReportAuthorized: false,
    isMiniReportAuthorizedKeyExists: false,
    modal: false,
    name: "",
    error: [],
    id: "",
    modal_dents: false,
    TotalDentCount: "",
    modal_Auth: false,
    ReportGenerated: false,
    customerCompany: '',
    PDFPrintShow: false,
    PDFPrintHide: true
  };
  count = [];
  pageLanguage = {
    ch: "Seite",
    fr: "Page",
    en: "Page",
  };
  pageOfLanguage = {
    ch: "von",
    fr: "de",
    en: "of",
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  setShowPDFPrint = () => {
    this.setState({ PDFPrintShow: true });
  }

  setHidePDFPrint = () => {
    this.setState({ PDFPrintHide: false });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let obj = {}
    if (nextProps.fullData) {
      obj.Authorized = nextProps.fullData.Authorized
      obj.fullData = nextProps.fullData
    }
    if (nextProps.lang !== prevState.lang) {
      obj.lang = nextProps.lang
    }
    // if (nextProps.lang !== prevState.lang) {
    //   return { lang: nextProps.lang };
    // } else return null; 
    return Object.keys(obj).length ? obj : null;
  }
  componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.fullData) {
      this.setState({
        Authorized: nextProps.fullData.Authorized,
        fullData: nextProps.fullData
      })
    }
  }
  async componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    await this.getData(selectedFile);
    this.getLang();
  }
  getData = async (selectedFile) => {
    Axios.get(
      `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
    ).then((r) => {
      this.setState({
        Authorized: r.data.Authorized ? r.data.Authorized : false,
        id: r.data.Authorized ? r.data.DriveThrough == "1" ? "drive_in" : "drive_through" : "",
        jsonData: r.data,
        MiniReportAuthorized: r.data.MiniReportAuthorized,
        isMiniReportAuthorizedKeyExists: r.data.hasOwnProperty("MiniReportAuthorized"),
        TotalDentCount: r.data.TotalDentCount ? r.data.TotalDentCount : "0",
        ReportGenerated: r.data.ReportGenerated,
        name: r.data.AuthorizedName,
        ReportGeneratedStatus: r.data.hasOwnProperty('ReportGeneratedStatus') ? r.data.ReportGeneratedStatus : 'FAIL',
        customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '',
      }, () => {
        this.showWarningMessageForZurich()
        this.checkStatus()
      })
    }).catch(error => alert('An error occured please try again'));
  };

  showWarningMessageForZurich = () => {
    const { customerCompany } = this.state;
    let zurichArr = ['zürich', 'zurich', 'zurigo', 'zurich', 'z%c3%bcrich+versicherung'];
    const isZurichClient = customerCompany ? zurichArr.includes(customerCompany.split(' ')[0].toLowerCase()) : false;
    if (isZurichClient) {
      Swal.fire({
        type: 'info',
        icon: 'info',
        title: this.lang('attention'),
        text: this.lang('zurichClientReportMessage'),
        confirmButtonText: 'OK',
        allowOutsideClick: false
      })
      .then((result) => {
        if (result.value) {
            if (this.props.history) {
                this.props.history.push('/DATswiss');
            } else {
                console.error('History is not defined');
            }
        }
    })
    .catch(error => {
        console.error('Error in Swal:', error);
    });
    }
  }
  checkStatus = () => {
    const { jsonData } = this.state;
    const isAnyOnecheck = jsonData.Dents && jsonData.Dents.some(item => (item.Replacing && item.Replacing == true) || (item.Preprints && item.Preprints == true));
    if (isAnyOnecheck) {
      Swal.fire({
        type: 'info',
        icon: 'info',
        title: this.lang('attention'),
        text: this.lang('The calculation report must be used for a combined repair!'),
        confirmButtonText: 'OK',
        allowOutsideClick: false
      })
      .then((result) => {
        if (result.value) {
            if (this.props.history) {
                this.props.history.push('/DATswiss');
            } else {
                console.error('History is not defined');
            }
        }
    })
    .catch(error => {
        console.error('Error in Swal:', error);
    });
    }
  }

  // authorize = () =>{
  //   this.props.history.push('/newTabview')
  // }

  internalStatus = async (vin) => {
    const url = configuration.internalStatus;
    let payload = {
      vin: vin,
      status: 3,
    }
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    await Axios.post(url, payload, { headers })
  }


  authorize = async () => {
    this.setState({
      modal_Auth: true
    })
    const { id } = this.state;
    var driveinid = id === "drive_in" ? "1" : "0"
    // for get updated JSON
    // this.getData(localStorage.getItem("selectedFile"),"Authorized");
    const { fullData } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading: true
    })
    let totalDents = 0;
    await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
      if (row.Part === 'TrunkCover') {
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      if (row.Part !== 'Trunk') {
        totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
      }
    })
    this.setState({
      fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
    }, async () => {

      let payload = {
        ...this.state.fullData,
        Authorized: true,
        MiniReportAuthorized: false,
        AuthorizedName: this.state.name,
        DriveThrough: 1,
        ReportGenerated: true
      }
      const url = configuration.generatePDF;
      await Axios.post(url1, { ...fullData, MiniReportAuthorized: true, Authorized: false, DriveThrough: driveinid, ReportGenerated: false, AuthorizedName: this.state.name, ReportGeneratedStatus: 'PENDING' })
        .then(async (res) => {
          await Axios.post(url, {
            partnerId,
            vin
          }).then((res) => {
            this.state.fullData.Authorized = true
            if (res.data.status === 200) {
              this.internalStatus(vin);
              this.setState({
                loading: false,
                Authorized: true, //for updating local state instantly
                MiniReportAuthorized: true,
                isMiniReportAuthorizedKeyExists: true,
                modal_Auth: false
              });
              Toast.fire({
                type: "success",
                title: "PDF generated successfully!",
              });
              this.props.updateJsonData(this.state.fullData);
              // Axios.post(url1, payload)
              //   .then((res) => {
              //     this.setState({
              //       loading: false,
              //       Authorized: true, //for updating local state instantly
              //       MiniReportAuthorized: false,
              //       isMiniReportAuthorizedKeyExists: true,
              //       modal_Auth : false
              //     })
              //     Toast.fire({
              //       type: "success",
              //       title: "PDF generated successfully!",
              //     });
              //     this.props.updateJsonData(this.state.fullData);
              //   }).catch(err => {
              //     this.setState({
              //       loading: false,
              //       modal_Auth : false
              //     })
              //     // alert("Table update failed");
              //     Toast.fire({
              //       type: "error",
              //       title: "Table update failed",
              //     });
              //   });
            } else if (res.data.status === 500) {
              this.setState({
                loading: false,
                modal_Auth: false
              })
              // vin or partner Id missing
              Toast.fire({
                type: "error",
                title: "Something went wrong!",
              });
            } else {
              this.setState({
                loading: false,
                modal_Auth: false
              })
              Toast.fire({
                type: "error",
                title: "pdf generate failed",
              });
            }
            // alert("data updated");
          }).catch(err => {
            this.setState({
              loading: false,
              modal_Auth: false
            })
            Toast.fire({
              type: "error",
              title: "pdf generate failed",
            });
          });
        })
    })
  }

  authorizedrivethrough = async () => {
    this.setState({
      modal_Auth: true
    })
    const { id } = this.state;
    var driveinid = id === "drive_in" ? "1" : "0"
    // for get updated JSON
    // this.getData(localStorage.getItem("selectedFile"),"Authorized");
    const { fullData } = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading: true
    })
    let totalDents = 0;
    await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row, i) => {
      if (row.Part === 'TrunkCover') {
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A'] + fullData.Dents[i]['B'] + fullData.Dents[i]['C'];
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      if (row.Part !== 'Trunk') {
        totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
      }
    })
    this.setState({
      fullData: { ...this.state.fullData, 'TotalDentCount': totalDents }
    }, async () => {
      let payload = {
        ...this.state.fullData,
        Authorized: true,
        MiniReportAuthorized: true,
        AuthorizedName: this.state.name,
        DriveThrough: 0,
        // ReportGenerated : true,
        ReportGeneratedStatus: 'PENDING'
      }
      const url = configuration.automated_scripts;
      let payload1 = {
        partnerId,
        vin,
        authorizer_name: this.state.name
      }
      await Axios.post(url1, { ...fullData, Authorized: false, DriveThrough: driveinid, ReportGenerated: false })
        .then(async (res) => {
          await Axios.post(url, payload1)
            .then(async (res) => {
              this.internalStatus(vin);
              this.state.fullData.Authorized = true
              if (res.status === 200) {
                Axios.post(url1, payload)
                  .then((res) => {
                    this.setState({
                      loading: false,
                      Authorized: true, //for updating local state instantly
                      MiniReportAuthorized: true,
                      isMiniReportAuthorizedKeyExists: true,
                      modal_Auth: false
                    })
                    Toast.fire({
                      type: "success",
                      // title: "PDF generated successfully!",
                      title: this.lang("All reports are being generated. Please check All Scan Records page after sometime."),
                    });
                    this.props.updateJsonData(this.state.fullData);
                  }).catch(err => {
                    this.setState({
                      loading: false,
                      modal_Auth: false
                    })
                    // alert("Table update failed");
                    Toast.fire({
                      type: "error",
                      title: "Table update failed",
                    });
                  });
              } else if (res.data.status === 500) {
                this.setState({
                  loading: false,
                  modal_Auth: false
                })
                // vin or partner Id missing
                Toast.fire({
                  type: "error",
                  title: "Something went wrong!",
                });
              } else {
                this.setState({
                  loading: false,
                  modal_Auth: false
                })
                Toast.fire({
                  type: "error",
                  title: "pdf generate failed",
                });
              }
            }).catch(err => {
            })
        }).catch(err => {
        })
    })
  }

  deAuthorize = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}`;
    this.setState({
      deAuthLoading: true
    })
    this.state.fullData.Authorized = false
    this.state.id = ""
    let payload = {
      ...this.state.fullData,
      ...this.state.id,
      Authorized: false,
      MiniReportAuthorized: false,
      ReportGenerated: false,
      AuthorizedName: this.state.name,
      ReportGeneratedStatus: 'PENDING'
    }
    Axios.post(url1, payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "De-Authorize PDF successfully!",
      });
      this.setState({
        Authorized: false,
        deAuthLoading: false,
        MiniReportAuthorized: false,
        id: "",
        // isMiniReportAuthorizedKeyExists:true
      })
      this.props.updateJsonData(this.state.fullData);
    }).catch(err => {
      this.setState({
        deAuthLoading: false
      })
      alert("Table update failed");
    });
  }

  handleChange = (e) => {
    // this.setState({
    //   [ e.target.name] : e.target.value
    //   })
    const inputValue = e.target.value;
    const cleanedInput = inputValue.trimStart();
    // const cleanedInput = inputValue.replace(/[^a-z\s]/gi, '');
    this.setState({
      name: cleanedInput
    })
  }

  handleSave = () => {
    const { name, id } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let error = [];
    if (name.trim() == "") {
      error.push("Please enter your name")
    }
    if (error.length) {
      this.setState({
        error: error,
        modal: true
      })
    } else {
      this.setState({
        error: [],
      })
    }
    if (id == "drive_in") {
      const url = configuration.authorizernamestore + `?partnerId=${partnerId}&vin=${vin}&name=${name}&drive_type=${"drive_in"}`;
      Axios.post(url).then((res) => {
        if (res.data.status === 200) {
          if (!error.length) {
            window.history.pushState(null, "", window.location.href);
            window.onpopstate = function () {
              window.history.pushState(null, "", window.location.href);
            };
            this.authorize();
            this.setState({ modal: false, })
          }
        }
      })
    } else {
      if (!error.length) {
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = function () {
          window.history.pushState(null, "", window.location.href);
        };
        this.authorizedrivethrough();
        this.setState({ modal: false })
      }
    }
  }


  render() {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    const vin = localStorage.getItem("selectedFile");
    const client = localStorage.getItem("client")
    const { ReportGeneratedStatus, Authorized, PDFPrintShow, PDFPrintHide } = this.state;
    return (
      <div className="animated fadeIn">
        <div xs="12" sm="12" className="p-2">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small> {client === "SWISS" || client === "POLAND" ? <span>{this.lang("DashboardVIN")} : </span> : <span>{this.lang("VIN Number")} : </span>} {localStorage.getItem("selectedFile")}</small>
                    {/* <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small> */}
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                      {/* <button
                        id="drive_in"
                        className={`glass btn btn-lg  ${this.state.Authorized && this.state.id == "drive_in"  ? 'btn-success' : 'btn-danger'} mr-1`}
                        disabled={this.state.loading || this.state.Authorized || (this.state.id == "drive_through" && this.state.Authorized)}
                        onClick={() => this.state.TotalDentCount == 0 ?  this.setState({modal_dents : true, id : "drive_in"}) : this.setState({modal : true, id : "drive_in"})}
                        >
                        {this.state.loading && this.state.id == "drive_in" ?
                          <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                            <span className="sr-only">Loading...</span>
                          </div>
                          :
                          <i className="fa fa-print" />
                        }
                        &nbsp; {this.lang("Authorize PDF Drive-In")}
                      </button> */}
                      {/* <button 
                        className={`glass btn btn-lg ${this.state.Authorized && this.state.id == "drive_through" ? 'btn-success' : 'btn-danger'} mr-1`}
                        id="drive_through"
                        // disabled
                        disabled={this.state.loading || this.state.Authorized || (!this.state.loading && this.state.id == "drive_in" && this.state.Authorized)}
                        // onClick={() => this.setState({modal : true, id : "drive_through"})}
                        onClick={() => this.state.TotalDentCount == 0 ?  this.setState({modal_dents : true, id : "drive_through"}) : this.setState({modal : true, id : "drive_through"})}
                      >
                          {this.state.loading  && this.state.id == "drive_through" ? 
                          <div className="spinner-border" role="status" style={{width : "1.5rem", height : "1.5rem"}}>
                            <span className="sr-only">Loading...</span>
                          </div>
                        :
                          <i className="fa fa-print" />
                        }
                          &nbsp; {this.lang("Authorize PDF Drive-Through")}
                      </button> */}
                      {/* { Authorized && (ReportGeneratedStatus !== 'PENDING') && (
                        <button className={`glass btn mx-3 btn-lg btn-danger mr-1`}
                          disabled={!Authorized || Authorized && !MiniReportAuthorized}
                          onClick={() => this.deAuthorize()}>
                          {this.state.deAuthLoading ?
                            <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                              <span className="sr-only">Loading...</span>
                            </div>
                            :
                            <i className="fa fa-print" />
                          }
                          &nbsp; {this.lang("De-Authorize PDF")}
                        </button>
                      )} */}
                      <SwissMiniReportAuthorization  setShowPDFPrint={this.setShowPDFPrint} setHidePDFPrint={this.setHidePDFPrint}/>

                      {
                      client == "SWISS" && PDFPrintShow ?
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg" disabled={ this.state.loading || this.state.Authorized || (this.state.id == "drive_through" && this.state.Authorized)}>
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      />
                      : 
                      <>
                      {
                        client == "SWISS" && PDFPrintHide &&  Authorized && (this.state.ReportGenerated === true) && ReportGeneratedStatus !== 'PENDING' ?
                          <ReactToPrint
                            trigger={() => {
                              document.title = localStorage.getItem("selectedFile");
                              return (
                                <button className="btn btn-danger btn-lg" disabled={ this.state.loading || this.state.Authorized || (this.state.id == "drive_through" && this.state.Authorized)}>
                                  <i className="fa fa-print" /> {this.lang("Print PDF")}
                                </button>
                              );
                            }}
                            content={() => this.componentRef}
                          />
                          : ''
                      }
                      </>
                      }
                      {client !== "SWISS" ?
                      <ReactToPrint
                        trigger={() => {
                          document.title = localStorage.getItem("selectedFile");
                          return (
                            <button className="btn btn-danger btn-lg" disabled ={Authorized}>
                              <i className="fa fa-print" /> {this.lang("Print PDF")}
                            </button>
                          );
                        }}
                        content={() => this.componentRef}
                      /> : ''}
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <CardBody style={{ padding: 0 }}>
            <div
              className="container all-reports-top-wrapper swiss-report-wrapper"
              // id="divIdToPrint_swiss"
              ref={(el) => (this.componentRef = el)}
              style={{ padding: 0 }}
              data-content-name={this.pageOfLanguage[this.state.lang]}
            >


              <div id="front-page-card" className="row row-zero page-break-row report-full-wrapper" data-content-name={this.pageLanguage[this.state.lang]}>
                <div className="col-sm-12 full-height-col col-zero">
                  <Card>
                    <CardBody className="col-zero">
                      <div className="newFormatReport_wrapper headerRow">
                        <ReportHeader_Swiss />
                        {/* <div className="row w-100"> */}
                        {/* <CustomerInfoTable_newswiss /> */}
                        <Newswiss_CustomerInfoTable />
                        <NewSwissPriceTable getUpdatedStateFromPriceTable={(data) => this.getUpdatedStateFromPriceTable(data)} />
                        {/* </div> */}
                      </div>
                    </CardBody>
                    <div id="report_page_one">
                      <ReportFooter_Swiss pageNo={1} reportType='newReportFull' />
                    </div>
                    {/* <CardFooter className="card-footer-bg">
                        </CardFooter> */}
                  </Card>
                </div>
              </div>
              <div id="front-page-card-two" className="row row-zero page-break-row report-full-wrapper second-svg-section" data-content-name={this.pageLanguage[this.state.lang]}>
                <div className="col-sm-12 full-height-col col-zero">
                  <Card className="show-footer">
                    <CardBody className="col-zero">
                      <div className="newFormatReport_wrapper">
                        <ReportHeader_Swiss />
                        <div className="container car-svg-main">
                          <div className="row title-row-main">
                            <div className="col-sm-12 col-zero">
                              <h3 className="report-title">
                                {this.lang("2D")}<span> {this.lang("View")}</span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 text-center">
                              <CarSvgSwiss {...this.props} reportType='newReportFull' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <div id="report_page_two">
                      <ReportFooter_Swiss pageNo={2} reportType='newReportFull' />
                    </div>
                    {/* <CardFooter className="card-footer-bg">
                      </CardFooter> */}
                  </Card>
                </div>
              </div>
            </div>
          </CardBody>
          {/* <div>
            <Card>
              <CardBody>
                <Link className="glass" to="/ReportFull">
                  <button className="btn btn-danger btn-sm pull-right">
                    <i className="fa fa-dot-circle-o"></i> {">>"}
                  </button>
                </Link>
                <Link className="glass" to="/TabView">
                  <button
                    style={{ marginRight: 10 }}
                    className="btn btn-danger btn-sm pull-right"
                  >
                    {"<<"} <i className="fa fa-dot-circle-o"></i>
                  </button>
                </Link>
              </CardBody>
            </Card>
          </div> */}
        </div>
        <div>
          <ScrollToTop />
        </div>

        <Modal isOpen={this.state.modal} className="authorizer_name_modal" backdrop="static"
          toggle={() => this.setState({ modal: false })}
        >
          <ModalHeader className="align-item-center">{this.lang("Authorizer name")}</ModalHeader>
          <ModalBody>
            <form>
              <div className="form_group">
                {/* {this.state.id === "drive_through" &&
          <p>{this.lang("This is a test feature and not intended for general use. Proceed further only if you are authorized to do so.")}</p>} */}
                <input className="form-control" placeholder={this.lang("Authorizer name")} type="text"
                  name="name"
                  value={this.state.name}
                  onChange={(e) => this.handleChange(e)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      this.handleSave()
                    }
                  }}
                />
                {this.state.error.includes('Please enter your name') && <span style={{ color: "red" }}>{this.lang("Please enter your name")}</span>}

              </div>
            </form>
          </ModalBody>
          <ModalFooter>
            <div>
              <Button color="secondary" className="btn btn-md p-2 mr-2" onClick={() => this.setState({ modal: false })}> {this.lang("Cancel")} </Button>
              <Button color="secondary" className="btn btn-md p-2 btn-danger" onClick={() => this.handleSave()}> {this.lang("Save")} </Button>
            </div>
          </ModalFooter>
        </Modal>

        <Modal size="md" isOpen={this.state.modal_dents} className="dent_zero_modal" backdrop="static"
          toggle={() => this.setState({ modal_dents: false })}>
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image"><b>{this.lang("The total number of dents is 0. Would you still like to authorize.")}</b></p>
            <button className="btn btn-danger p-2 mr-2" onClick={() => this.setState({ modal: true, modal_dents: false })}> {this.lang("Yes")} </button>
            <button className="btn btn-cancel p-2" onClick={() => this.setState({ modal_dents: false })}> {this.lang("No")} </button>
          </ModalBody>
        </Modal>

        <Modal centered size="lg" isOpen={this.state.modal_Auth} className="authorise_modalpopup" backdrop="static"
          toggle={() => this.setState({ modal_Auth: false })}>
          <ModalBody className="text-center">
            <p className="mb-3 text-message-extra-image"><b>{this.lang("Please wait Authorization in progress")}<span className="dot-flashing"></span></b></p>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    fullData: props.jsonData
  };
};
export default connect(mapStateToProps, {
  updateJsonData
})(NewReportMiniSwiss);